import cClipboard from './cClipboard.vue';

export default {
  install(Vue) {
    Vue.component('cClipboard', cClipboard);
  },
};
